import { format } from 'date-fns';
import { RRule, rrulestr } from 'rrule';

/**
 * Format time range like react-big-calendar does (e.g., "8:00 AM - 9:00 AM")
 */
export const formatTimeRange = (start: Date, end: Date): string => {
  const startTime = format(start, 'h:mm a');
  const endTime = format(end, 'h:mm a');
  return `${startTime} - ${endTime}`;
};

/**
 * Convert rrule string to human-readable text
 */
export const getRecurrenceText = (rruleString: string): string => {
  try {
    const rule = rrulestr(rruleString);
    if (rule instanceof RRule) {
      return rule.toText();
    }
    return rruleString; // Fallback to raw string if parsing fails
  } catch (error) {
    console.error('Error parsing rrule:', error);
    return 'Custom recurrence';
  }
};

/**
 * Format full date/time range (e.g., "Mon, Sep 30, 2025 from 9:00-9:30am")
 */
export const formatDateTimeRange = (start: Date, end: Date): string => {
  const datePart = format(start, 'EEE, MMM d, yyyy');
  const startTime = format(start, 'h:mm');
  const endTime = format(end, 'h:mm');
  const startPeriod = format(start, 'a');
  const endPeriod = format(end, 'a');

  // If same AM/PM period, only show period once at the end
  const timePart =
    startPeriod === endPeriod
      ? `${startTime}-${endTime}${endPeriod.toLowerCase()}`
      : `${startTime}${startPeriod.toLowerCase()}-${endTime}${endPeriod.toLowerCase()}`;

  return `${datePart} from ${timePart}`;
};
